import React, { useState, useEffect } from 'react';
import './App.css';
import './index.css'; // import Tailwind CSS styles
import FloatingMenu from './components/FloatingMenu';
import computer from '../src/images/computer_banner.png';
import Footer from './components/Footer';
import Contact from './pages/contact';
import About from './pages/about';
import WorkPreviews from './components/WorkPreviews';
import WorkDetail from './components/WorkDetail';
import { Route } from 'react-router-dom';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ReactTypingEffect from 'react-typing-effect';
import Error404 from './components/Error404';

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      // Wait for the fade out animation to finish before setting loading to false
      setTimeout(() => {
        setLoading(false);
      }, 900); // Adjust this timeout to match your CSS transition duration
    }, 1000); // Set loading to false after 1000ms delay
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Apply overflow: hidden to the body when the preloader is visible
    if (!fadeOut) {
      document.body.style.overflow = 'hidden';
    } else {
      // Remove overflow: hidden when the preloader disappears
      document.body.style.overflow = 'visible';
    }
  }, [fadeOut]);

  const menuStyle = {
    cursor: 'pointer',
  };

  return (
    <div className="App">
      {loading ? ( // Display loading screen if loading state is true
        <div
          className="loading-screen"
          style={{
            backgroundColor: '#fffdf6',
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            opacity: fadeOut ? 0 : 1, // Apply opacity when fading out
            transition: 'opacity 1s ease-in-out', // Smooth transition
          }}
        >
          <h2 style={{ color: 'black', fontSize: '50px'}}>
            Loading{' '}
            <ReactTypingEffect
              text={["..."]}
              speed={110}
              eraseDelay={10}
              typingDelay={50}
              cursor=" "
            />
          </h2>
          {/* Load image while loading */}
          <img src="https://i.imgur.com/ryhGEpo.jpeg" alt="Loading" style={{ display: 'none' }} />
          <img src={computer} style={{ display: 'none' }} alt="Banner Image" />
        </div>
      ) : (
        <>
          {/* top header menu */}
          <div className="mb-20 menu-fix">
            <FloatingMenu style={menuStyle} />
          </div>

          {/* work previews or work detail */}
          <Router>
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<WorkPreviews />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/work/:slug" element={<WorkDetail />} />
                <Route path="*" element={<Error404 />} />
              </Routes>
            </AnimatePresence>
          </Router>

          {/* Footer */}
          <div className="mt-20">
            <Footer />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
